<mat-card class="error-message-box">
  <mat-card-header>
    <mat-card-title *ngIf="!data?.isReport">{{ 'error-message.title' | translate }}</mat-card-title>
    <mat-card-title *ngIf="data?.isReport">{{ 'error-message.title-report' | translate }}</mat-card-title>
    <!-- <mat-card-subtitle>[Historique message]</mat-card-subtitle> -->
  </mat-card-header>
  <form [formGroup]="errorMessageForm" (ngSubmit)="onSubmit()">
    <mat-card-content class="error-message-card-content">
      <div *ngFor="let errorMessage of errorMessages" class="error-message-div">
        <span class="error-message-info">{{errorMessage.creationDate | date : 'dd/MM/yyyy HH:mm:ss' }}
          {{ errorMessage?.creationUser?.firstName}}
          {{ errorMessage?.creationUser?.lastName}}
        </span>
        <span class="error-message-message">{{errorMessage.message}}</span>
      </div>

      <mat-form-field style="width: 95%; margin-top: 20px;">
        <textarea rows="5" formControlName="message" matInput
          placeholder="{{ 'error-message.add-message' | translate }}" style="width: 100%;"></textarea>
      </mat-form-field>

    </mat-card-content>
    <mat-card-actions class="error-card-action">
      <button mat-raised-button type="button" color="primary" (click)="onRemoveError()"  *ngIf="!data?.isReport && data.isInError && uiService.visibleByRole([Role.manager, Role.administrator])">
        <mat-icon>check</mat-icon>{{ 'button.remove-error' | translate }}
      </button>
      <button mat-raised-button type="button" color="warn" (click)="onCancel()">
        <mat-icon>clear</mat-icon>{{ 'button.cancel' | translate }}
      </button>
      <button mat-raised-button color="primary" [disabled]="errorMessageForm.invalid">
        <mat-icon>send</mat-icon> {{ 'button.send' | translate }}
      </button>
    </mat-card-actions>
  </form>
</mat-card>